import './Navbar.css';
import React from "react";
import { Link } from "react-router-dom";

const navbar = () => {
    return (
        <div className='nav-container'>
            <div className='nav-links-container' >
                <ul className='nav-links'>
                    <li>
                        <Link className="nav-link" to="/">Home</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/history">History</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/trustees">Trustees</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/policy">Policy & Guidelines</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/apply">Apply</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/news">Previous Grants</Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/contact">Contact & FAQs</Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default navbar;